/** Resolve a provider voice after an outage when onboarding cannot load the catalog. */
export const AUTOMATIC_ONBOARDING_VOICE_ID = "__automatic_onboarding_voice__"
